import {fetchTemplate} from '@components/Template/templateSlice';
import fetchCommonRefs from './fetchCommonRefs';

export default function fetchTemplatePage({
    store, headers, baseUrl, params, options
}) {
    return [
        store.dispatch(fetchTemplate({headers, params, options})),
        ...fetchCommonRefs({
            store, headers, baseUrl, options
        })
    ];
}
